import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";

/**
 * Use Case: Delete PASCO
 * Deletes a PASCO record from the system
 */
export class DeletePascoUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    /**
     * Execute the use case
     * @param pascoId - The unique identifier of the PASCO to delete
     * @returns Promise<void>
     * @throws Error if pascoId is invalid
     */
    async execute(pascoId: string): Promise<void> {
        if (!pascoId || pascoId.trim() === '') {
            throw new Error('PASCO ID is required');
        }

        await this.pascoRepository.delete(pascoId);
    }
}
